export const VACINACAO_VIEWS = {
  REGISTRO: 'registro',
  IMPORTAR: 'importar',
  TUTORIAL: 'tutorial',
}
